import { makeStyles, Typography } from "@material-ui/core";
import olpLogoWhite from "../../Images/olp-logo-white.svg";


const FooterBar = () => {

    const useStyles = makeStyles(theme => ({
        style: {
            backgroundColor: '#264c59',
            borderTop: "1px solid #264c59",
            textAlign: "center",
            padding: 0,
            position: "fixed",
            left: "0",
            bottom: "0",
            width: "100%",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        links: {
            transition: '0.6s',
            "&:hover": {
                color: theme.palette.primary.light,
                cursor: 'pointer'
            }
        },
        a: {
            color: 'inherit',
            textDecoration: 'none',
            textAlign: 'center'
        },
        footerSmallPrint: {
            color: '#b3b3b3',
            fontSize: 12
        }
    }));

    const classes = useStyles();

    return (
        <div className={classes.style}>
            <img style={{ paddingBottom: 0, maxWidth: 200, minWidth: 100 }} src={olpLogoWhite} alt="Oxford Lymphoedema Practice logo in white" id="footer-logo" />
            <div className={classes.break}></div>
            <p className={classes.footerSmallPrint}>© Oxford Lymphoedema Practice Ltd 2023</p>
        </div>
    );
}

export default FooterBar;